import type { RouteObject } from 'react-router';

import { PATHNAMES } from 'constants/constants';
import { lazyRoute } from 'utils/lazyRoute';

const GeneralAssistant = lazyRoute(
  () => import('features/GeneralAssistant/components/GeneralAssistant'),
  m => m.GeneralAssistant,
);
const GeneralAssistantSetupPage = lazyRoute(
  () => import('features/GeneralAssistant/components/SetupProject/GeneralAssistantSetupPage'),
  m => m.GeneralAssistantSetupPage,
);

export const generalAssistantRoutes: RouteObject[] = [
  { path: PATHNAMES.generalAssistantNew, lazy: GeneralAssistantSetupPage },
  { path: `${PATHNAMES.generalAssistant}/:id`, lazy: GeneralAssistant },
];
